export type TelemetrySource = "analytics" | "eventbus";
export type TelemetryEventCategory = "in-session" | "lifecycle";

export interface TelemetryEnvelope {
  readonly eventCategory?: TelemetryEventCategory;
  readonly customerId: string;
  readonly source: TelemetrySource;
  readonly eventType: string;
  readonly eventUid: string;
  readonly originatingUserId: string;
  readonly timestampMillis: number;
  readonly propsJson: string | null;
}

export interface ITelemetryService {
  capture(envelope: TelemetryEnvelope): void;
  flushPending(): Promise<void>;
  dispose(): Promise<void>;
}

export const TELEMETRY_SERVICE = Symbol.for("Campfire.TelemetryService");
